import Facebook from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import Twitter from '@mui/icons-material/Twitter';
import YouTube from '@mui/icons-material/YouTube';
import { Box, Grid, Link, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import ConfigContext from '../context/config';
import useNonNullContext from '../hooks/useNonNullContext';
import LayoutV2 from 'src/components/LayoutV2';
import Header from 'src/components/LayoutV2/header';
import Back from 'src/components/LayoutV2/header/back';
import Logo from 'src/components/LayoutV2/header/logo';
import AccountMenu from 'src/components/LayoutV2/account-menu';
import Footer from 'src/components/Footer';
import { useRouter } from 'next/router';

export default function Custom404() {
  const tenant = useNonNullContext(ConfigContext);
  const socialLinks = tenant.footer.contactInfoSection.socialLinks || [];

  const theme = useTheme();
  const color = theme.palette.common.black;

  const router = useRouter();

  return (
    <LayoutV2
      header={
        <Header
          leftContent={
            <>
              <Back onClickCallback={() => router.push('/dashboard')} />
              <Logo />
            </>
          }
          rightContent={<AccountMenu />}
        />
      }
      footer={<Footer isShowingCart={false} />}
    >
      <Box
        sx={{
          backgroundImage:
            "url('https://territory-assets.s3.amazonaws.com/static/error_pages/404bgImage@2x.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center bottom',
          height: '80vh',
          marginBottom: '-2rem',
        }}
      >
        <Grid
          container
          sx={{
            flexDirection: 'column',
            textAlign: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant={'h2'} sx={{ marginTop: '5rem' }}>
            Well, this is weird
          </Typography>
          <Typography variant={'body1'} sx={{ marginBottom: '2rem' }}>
            We can&apos;t find this page, but you just found yourself some share
            buttons.
          </Typography>
          <Grid
            container
            direction={'row'}
            sx={{
              justifyContent: 'center',
            }}
          >
            {socialLinks?.map((socialLink) => {
              return (
                <Link
                  key={socialLink.hrefUrl}
                  href={socialLink.hrefUrl}
                  className="social-link"
                  sx={{ color: color, padding: '0.5rem' }}
                >
                  {socialLink.logoAssetUrl === 'Facebook' && <Facebook />}
                  {socialLink.logoAssetUrl === 'Instagram' && <Instagram />}
                  {socialLink.logoAssetUrl === 'Twitter' && <Twitter />}
                  {socialLink.logoAssetUrl === 'YouTube' && <YouTube />}
                </Link>
              );
            })}
          </Grid>
        </Grid>
      </Box>
    </LayoutV2>
  );
}
